/**
 * hero-slider-premium.js
 * Controls slide switching (crossfade), autoplay with pause-on-hover,
 * arrow/dot navigation, keyboard arrows, and restarting the per-slide
 * Ken Burns background zoom + staggered text/accent reveal each time a
 * slide activates.
 */
(function () {
  'use strict';

  function initHeroSlider(root) {
    var slides = root.querySelectorAll('[data-hero-slide]');
    if (slides.length === 0) return;

    var dots = root.querySelectorAll('[data-hero-dot]');
    var prevBtn = root.querySelector('[data-hero-prev]');
    var nextBtn = root.querySelector('[data-hero-next]');

    var currentIndex = 0;
    var autoplay = root.dataset.autoplay === 'true';
    var speed = parseInt(root.dataset.autoplaySpeed, 10) || 6000;
    var timer = null;

    function restartAnimations(slide) {
      var animatedEls = slide.querySelectorAll('[data-hero-reveal], .hero-slide__image');
      animatedEls.forEach(function (el) {
        el.style.animation = 'none';
        el.style.transition = 'none';
        void el.offsetWidth;
        el.style.animation = '';
        el.style.transition = '';
      });
    }

    function goTo(index) {
      if (slides.length <= 1) return;
      if (index >= slides.length) index = 0;
      if (index < 0) index = slides.length - 1;
      if (index === currentIndex) return;

      slides[currentIndex].classList.remove('is-active');
      if (dots[currentIndex]) {
        dots[currentIndex].classList.remove('is-active');
        dots[currentIndex].setAttribute('aria-selected', 'false');
      }

      currentIndex = index;

      slides[currentIndex].classList.add('is-active');
      restartAnimations(slides[currentIndex]);
      if (dots[currentIndex]) {
        dots[currentIndex].classList.add('is-active');
        dots[currentIndex].setAttribute('aria-selected', 'true');
      }
    }

    function next() { goTo(currentIndex + 1); }
    function prev() { goTo(currentIndex - 1); }

    function startAutoplay() {
      if (!autoplay || slides.length <= 1) return;
      stopAutoplay();
      timer = window.setInterval(next, speed);
    }
    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.index, 10));
        startAutoplay();
      });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    root.setAttribute('tabindex', '-1');
    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') { next(); startAutoplay(); }
      if (event.key === 'ArrowLeft') { prev(); startAutoplay(); }
    });

    restartAnimations(slides[currentIndex]);
    startAutoplay();
  }

  document.querySelectorAll('[data-hero-slider]').forEach(initHeroSlider);

})();
